<div>
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <app-metadata-field [data]="data"></app-metadata-field>
  <div class="metadata-block">
    <div>
      <div class="metadata-key">Key:</div>
      <div class="metadata-value">{{ data.key }}</div>
    </div>
    <div fxLayout="row wrap" [formGroup]="form" id="form">
      <label for="label" title="{{ data.id }}">Label</label> &nbsp;
      <input formControlName="heading" class="widget-attr" id="label" type="text" placeholder="{{ data.label }}"
             [(ngModel)]="data.label" />
      <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
      <label class="widget-attr" for="desc">Description</label> &nbsp;
      <input class="widget-attr" formControlName="description" id="desc" type="text" [(ngModel)]="data.description" />
      <div *ngIf="form?.get('description')?.hasError('maxlength')" class="error-msg">
        Max 100 characters are allowed
      </div>
    </div>
  </div>
  <div class="metadata-properties" fxLayout="row nowrap">    
    <label><input class="metadata-key" type="checkbox" [(ngModel)]="data.required" />Required</label>
  </div>
</div>
